import { Gamification } from '../../components/gamification/Gamification'

export default {
    //Splash
    splash_message: 'Plataforma de comunicación y entrenamiento',

    //TTCC
    accept_ttcc: 'Aceptar Términos & Condiciones',

    modal_not_connected: 'Te encuentras sin conexión',
    modal_not_connected_message:
        'Para acceder a la aplicación y disfrutar de todas sus funciones, asegúrate de estar conectado a una red Wi-Fi o de datos móviles.',
    //Login
    welcome: '¡Bienvenido!',
    welcome_message:
        'dots, tu nuevo aliado tecnológico en la comunicación y capacitación.',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    code: 'Código',
    recover_password: '¿Olvidaste tu contraseña?',
    log_in: 'Iniciar sesión',
    log_in_biometrics: 'Ingresar con datos biométricos',
    create_user: 'Crear usuario',
    recover_access_to_account:
        'Ingresa tu usuario para recuperar el acceso a tu cuenta',
    back: 'Volver',
    enter_new_password: 'Ingresa el código y tu nueva contraseña',
    enter_code: 'Ingresa el código',
    new_password: 'Nueva contraseña',
    repeat_new_password: 'Repetir nueva contraseña',
    validate: 'Validar',
    complete_all_fields: 'Completa todos los campos',
    passwords_do_not_match: 'Las contraseñas no coinciden',
    user_created_successfully: 'Usuario creado con éxito',
    create_user: 'Crear usuario',
    required_fields: 'Campos obligatorios',
    confirm_your_email: 'Confirma tu email',
    confirm_your_phone: 'Confirma tu teléfono',
    confirm_password: 'Confirma tu contraseña',
    modifying_email: 'Estás modificando tu email',
    validate_code: 'Validar código',
    code_sent_successfully: 'Revisá tu correo 📩',
    password_reset: 'Se ha reiniciado su contraseña con éxito',
    enter_confirmation_code: 'Ingrese su código de confirmación',
    enter_your_new_email: 'Ingresa tu nuevo email',
    //nuevos al 01-08-2024
    user_does_not_exist: '¡Ups! No encontramos tu cuenta',
    contact_the_administrator:
        'Parece que el usuario que ingresaste no existe.\nVerifica que esté escrito correctamente\no comunicate con el administrador.',
    invalid_user_or_pass: 'Usuario y/o contraseña inválida',
    info_is_not_correct:
        'Alguno de los datos no son correctos, por favor vuelva a intentarlo.',
    enter_user: 'Por favor, ingrese un usuario',
    nonexistent_user: 'Usuario inexistente. Por favor, vuelve a intentarlo.',
    incorrect_code: 'Código incorrecto',
    change_saved_successfully: 'Cambio guardado con éxito',
    pass_changed_successfully: 'La contraseña se ha cambiado correctamente',
    check_your_email:
        'Te enviamos un código para continuar con el cambio de contraseña.',
    eight_characters: '*Debe contener más de 8 caracteres',
    one_uppercase_letter: '*Debe contener al menos 1 letra mayúscula',
    one_special_character: '*Debe contener al menos 1 caracter especial (@,$,!,#,?)',
    pass_requirements:
        'Debes cumplir los siguientes requisitos:\n\n*Debe contener más de 8 carácteres\n*Debe contener al menos 1 letra mayúscula\n*Debe contener al menos 1 carácter especial (ej: @, $, !, #, ?)',
    select_date: 'Selecciona una fecha',
    cannot_create_password: 'No se puede crear contraseña',
    complete_your_details: 'Complete sus datos para continuar',
    validate_code: 'Validar código',
    enter_valid_number: 'Debes ingresar un número válido',
    complete_numbers:
        'El prefijo "15" se debe eliminar para que el número final tenga 13 dígitos en total, ejemplo: +54 9 XXX XXX XXXX, debes completar los 10 números restantes.',

    //Profile
    insufficient_permissions: 'Permisos insuficientes',
    permissions_are_required:
        'Se necesitan permisos para acceder a la cámara y a la galería de fotos.',
    choose_font: 'Elegir fuente',
    where_do_you_want: '¿De dónde desea seleccionar la imagen?',
    camera: 'Cámara',
    gallery: 'Galería',
    edit_photo: 'Editar foto',
    cancel: 'Cancelar',
    save: 'Guardar',
    app: 'App',
    support: 'Soporte',
    other: 'Otro',
    contact_channel: 'Canal de contacto',
    select_the_contact_channel: 'Selecciona canal de contacto',
    subject: 'Asunto',
    write_the_subject: 'Describe el motivo del mensaje',
    message: 'Mensaje',
    write_a_comment: 'Escribe un comentario',
    send: 'Enviar',
    sent_successfully: 'Enviado con éxito',
    thank_you_for_leaving_us_your_comments:
        'Gracias por dejarnos tus comentarios,\npronto serás contactado.',
    close: 'Cerrar',
    check_for_update: 'Buscar actualización',
    clear_cache: 'Borrar caché',
    delete_account: 'Eliminar cuenta',
    log_out: 'Cerrar sesión',
    notifications: 'Notificaciones',
    configuration: 'Configuración',
    account: 'Cuenta',
    about: 'Acerca de',
    logout_confirmation: '¿Estás seguro que deseas cerrar sesión?',
    more_options_coming_soon:
        'Más opciones de configuración estarán disponibles próximamente.',
    insufficient_permissions: 'Permisos insuficientes',
    permissions_to_access:
        'Se necesitan permisos para acceder a la cámara y a la galería de fotos.',
    choose_font: 'Elegir fuente',
    select_the_image: '¿De dónde desea seleccionar la imagen?',
    change_language: 'Cambiar idioma',
    change_language_title: 'Importante!',
    change_language_message:
        'Para realizar esta acción, es necesario tener conexión a internet. Esto eliminará el contenido descargado para uso en modo offline. Tenga en cuenta que el cambio solo afectará al contenido de la app y no a la estructura de la misma, que depende del idioma de su dispositivo.',
    logout_not_available: 'Cierre de sesión no disponible',
    cant_logout:
        'No puedes cerrar sesión en este momento porque no tienes conexión a internet. Por favor, verifica tu conexión y vuelve a intentarlo.',
    //nuevos al 01-08-2024
    cache_cleared: 'Caché borrado exitosamente',
    deletes_the_content:
        'Esta acción elimina el contenido descargado para el uso de la app en modo offline. Asegurate de tener conexión para continuar navegando.',
    error_uploading_image: 'Error al subir la imagen: ',
    there_was_an_error:
        'Hubo un error al subir la imagen. Por favor, intenta de nuevo.',
    //nuevos al 21-11-2024
    email: 'Email',
    phone: 'Teléfono',
    name: 'Nombre',
    last_name: 'Apellido',
    role: 'Rol',
    verify: 'Verificar',
    verified: 'Verificado',
    contact_channels: 'Canales de contacto',
    editing_your_email: 'Estás editando tu email',
    editing_your_phone: 'Estás editando tu teléfono',
    modifying_your_email:
        'Estás modificando tu email, recibirás un código en tu correo electrónico para ingresarlo. Si aún no recibiste el código, vuelve a verificarlo.',
    modifying_your_phone:
        'Estás modificando el número de tu celular, recibirás un código SMS para ingresarlo. Si aún no recibiste el código, vuelve a verificarlo.',

    //Notifications
    all: 'Todo',
    unread: 'No leído',
    read: 'Leído',
    seen: 'Visto',
    notifications: 'Notificaciones',
    here_you_will_find: '¡Aquí encontrarás todas las alertas y notificaciones!',
    mark_all_read: 'Marcar todo leído',
    you_have_no_notifications: '¡No tienes notificaciones!',
    you_will_soon_start: 'Pronto comenzarás a recibir comunicaciones nuevas',

    //Buscador
    enter_your_search: 'Buscar',
    no_results: 'No hay resultados',
    search_content: 'Busca contenido que sea de tu interés.',
    see: 'Ver',
    results_in: 'resultados en',
    see_less_results: 'Ver menos resultados',
    all: 'Todo',
    wall: 'Muro',
    learning: 'Capacitación',
    benefits: 'Beneficios',
    portfolio: 'Portafolio',
    retry: 'Reintentar',
    locked: 'Bloqueado',
    pending: 'Pendiente',
    seen: 'Visto',
    approved: 'Aprobado',

    //Posts
    see_them: 'Ver los ',
    _comments: ' comentarios',
    reactions_from_other_users: 'Reacciones de otros usuarios',
    not_connected_to_the_network: 'No  estás conectado a la red',
    comment: 'Comentario',
    comments: 'Comentarios',
    write_a_comment: 'Escribe un comentario',
    no_content: 'No hay contenido',
    not_connected_to_the_network: 'No estás conectado a la red',
    reaction: 'Reacción',
    reactions: 'Reacciones',
    first_comment: 'Todavía no hay comentarios',
    no_comment: 'Sé la primera persona en comentar.',
    write_a_comment: 'Escribe un comentario',
    no_publications: 'No hay publicaciones',
    no_post_to_read: 'No tienes ninguna publicación por leer.',
    views: 'visualizaciones',
    reply: 'Responder',
    see: 'Ver ',
    more_answers: 'respuestas más',
    hide: 'Ocultar ',
    answers: ' respuestas',
    no_reactions: '¡Todavía no hay reacciones!',
    leave_your_reaction: 'Sé el primero en dejar tu reacción.',
    //nuevos al 01-08-2024
    full_survey: '¡Has completado la encuesta!',
    thanks_for_participating:
        '¡Gracias por participar! Estate atento/a al muro para más actualizaciones.',
    sent_automatically:
        'Se enviará automáticamente cuando vuelvas a tener conexión.',
    no_post_saved: 'Aún no hay publicaciones guardadas',
    see_your_favorite_content: 'Aquí verás tu contenido favorito.',
    //fechas
    instant: 'Hace instantes',
    hourFirst: 'Hace ',
    hour: ' hora',
    hours: ' horas',
    day: ' día',
    days: ' días',

    //Learning
    congratulations: '¡Felicitaciones!',
    you_approved: '¡Aprobaste con ',
    you_completed: 'Has completado este curso',
    you_disapproved: 'Evaluación desaprobada',
    score: 'Calificación:',
    return_to_course: 'Volver a Cursos',
    retry: 'Reintentar',
    it_is_available: 'Ya está disponible',
    total_course_evaluation: 'Evaluación total del curso',
    evaluate_me: 'EVALUARME',
    completed_the_course: 'Curso completado',
    pending_approval: 'Pendiende de aprobación',
    return: 'Volver',
    continue_course: 'Continuar curso',
    you_have_made: 'Has realizado el ',
    of_the_course: ' del curso',
    locked: 'bloqueado',
    pending: 'pendiente',
    seen: 'visto',
    complete: 'completo',
    reprobate: 'reprobado',
    sync_pend: 'sync pend.',
    in_progress: 'en curso',
    perform_evaluation: 'Realizar evaluación',
    next_content: 'Siguiente contenido',
    you_completed_all: 'Completaste todos los contenidos',
    final_evaluation: 'EVALUACIÓN FINAL',
    retry_mayus: 'REINTENTAR',
    see_more: '...ver más',
    see_less: '...ver menos',
    back_to_course: 'VOLVER AL CURSO',
    click_to_see: 'Click para ver',
    //Evaluaciones
    evaluation: 'Evaluación: ',
    of: ' de ',
    loading_evaluation: 'Cargando evaluación...',
    select_option: 'Debes seleccionar una opción para continuar',
    select_one_answer:
        'Por favor, seleccione al menos una respuesta para cada pregunta.',
    exit_evaluation: '¿Deseas salir de la evaluación?',
    your_answers_will_not_be_saved:
        'Si abandonas ahora, tus respuestas no se guardarán, y no obtendrás una calificación',
    continue_evaluation: 'Continuar con la evaluación',
    leave_anyway: 'Salir de todos modos',
    try_again: '¡Vuelve a intentarlo!',
    passed_the_evaluation: 'Has aprobado la evaluación',
    start_the_course_again:
        'No obtuviste la suficiente calificación para aprobar la evaluación. Inicia nuevamente el curso para poder superarlo.',
    evaluation_pending_approval: 'Evaluación pendiente de aprobación',
    notification_result_evaluation:
        'Pronto te llegará una notificación con el resultado de tu evaluación',
    write_here: 'Escribe aquí...',
    close: 'Cerrar',
    confirm: 'Confirmar',
    sync_pending: 'Pendiente de sync',
    view_certificate: 'Ver certificado',
    //nuevos al 27-01-2025
    course_download_in_process: 'Descarga de curso en proceso',
    course_is_downloading:
        'Por favor, aguarda unos segundos. El curso se está descargando para que puedas acceder a todo el contenido offline sin inconvenientes.',
    downloaded_course: 'Curso descargado correctamente',
    you_can_train_offline: '¡Listo! Ahora puedes entrenarte sin conexión.',
    delete_offline_course: '¿Quieres eliminar la descarga de este curso offline?',
    not_view_course_offline: 'No vas a poder visualizar este curso en modo offline.',
    course_is_not_available: 'El curso ya no está disponible...',
    not_available_offline:
        'Ya no está disponible offline, pero puedes descargarlo nuevamente cuando lo necesites.',
    content_download_in_process: 'Descarga de contenido en proceso',
    content_is_downloading:
        'Por favor, aguarda unos segundos. El contenido se está descargando para que puedas acceder a todo el contenido offline sin inconvenientes.',
    downloaded_content: 'Contenido descargado correctamente',
    delete_offline_content: '¿Deseas eliminar el contenido offline?',
    not_view_content_offline:
        'Al eliminarlo, ya no podrás acceder al contenido sin conexión.',
    content_is_not_available: 'El contenido ya no está disponible...',
    download_offline: 'Descargar offline',
    available_offline: 'Disponible offline',
    delete: 'Eliminar',

    //Stores
    your_progress_in_stores: 'Tu avance en tiendas',
    map: 'Ver mapa',
    daily_survey: 'Progreso mensual',
    survey: 'Encuestas',
    matutino: 'MATUTINO',
    vespertino: 'VESPERTINO',
    form: 'Formulario',
    enter_a_number: 'Ingresa un número',
    campaign_expiration: 'VTO. CAMPAÑA: ',
    store_indicators: 'Indicadores de tienda',
    last_days: 'Correspondiente a los últimos 30 días',
    main_indicators: 'Revisa avance de métricas clave.',
    store_information: 'Guía para alcanzar estándar óptimo.',
    perform_executions: 'Revisión en punto de venta.',
    pending_mayus: 'PENDIENTE',
    approved_mayus: 'APROBADO',
    in_review_mayus: 'EN REVISIÓN',
    redo_mayus: 'REHACER',
    visited_mayus: 'VISITADO',
    visited_mayus_sync: 'VISITADO SYNC',
    visited_store_mayus: 'TIENDAS VISITADAS',
    checkin_realized_sync: 'TIENDAS VISITADAS SYNC',
    moderation_mayus: 'MODERACIÓN',
    review_mayus: 'REVISAR',
    in_progress_mayus: 'EN CURSO',
    sync_pend_mayus: 'SYNC PEND.',
    locked_mayus: 'BLOQUEADO',
    complete_mayus: 'COMPLETO',
    perfect_store: 'Tienda perfecta',
    execution: 'Ejecución',
    vouchers: 'Vouchers',
    send: 'Enviar',
    requires: 'Requiere ',
    variation: 'Variación',
    validity: 'Vigencia: ',
    points: 'puntos',
    voucher_canceled: 'Voucher cancelado',
    you_can_try_again: '¡No te preocupes! Puedes volver a intentarlo.',
    voucher_successful: 'Voucher exitoso',
    successful_promo: '¡Se ha realizado la promo con éxito!',
    voucher_pending: 'Voucher pendiente',
    wait_for_the_validation: 'Espera a que se complete la validación de tu voucher',
    your_code_is_being_scanned: 'Tu código esta siendo escaneado ⏳',
    view_qr: 'Ver QR',
    return_to_store: 'Volver a Tienda',
    stores_objective: 'Debe cumplir el objetivo de tiendas.',
    welcome_stores: '¡Arma tu planificación!',
    tip_day:
        'Para estar al día, no olvides realizar la planificación completa de todas tus jornadas.',
    close_mayus: 'CERRAR',
    select_form: 'Selecciona un formulario para empezar',
    select_one_form:
        'Para iniciar el relevamiento debes seleccionar alguno de los formularios.',
    answer_all_questions: 'Debes responder todas las preguntas para continuar.',
    schedule_not_found: 'No se encontró la agenda para hoy.',
    form_not_found: 'Formulario no encontrado en la agenda.',
    send: 'Enviar',
    check_in: 'Check-in',
    check_out: 'Check-out',
    check_out_done: 'Check-out finalizado',
    off_route:
        'Te encuentras fuera de ruta, ingresa aquí para regresar a la agenda del día',
    search_barcode: 'Buscar por código de barras',
    no_agenda_today: '¡No tienes agendas para hoy!',
    no_agenda_week: '¡No tienes agenda para la semana!',
    no_information_today:
        'No cuentas con agenda para esta fecha, cualquier duda consulta con tu supervisor.',
    no_information_week:
        'No estamos recibiendo información para tu usuario, cualquier duda por favor comunicate con tu supervisor.',
    //nuevos al 01-08-2024
    not_have_camera_permissions: 'No tienes permisos de cámara',
    activate_from_settings:
        'Actívalo desde la configuración de tu dispositivo para poder continuar.',
    modify_permissions: 'Modificar permisos',
    complete_fields: 'Completa los siguientes campos para crear una tienda',
    create: 'Crear',
    store_name: 'Nombre de la tienda',
    enter_store_name: 'Ingresa nombre de la tienda',
    sore_address: 'Dirección',
    enter_sore_address: 'Ingresa dirección de la tienda',
    cluster: 'Cluster',
    store_phone: 'Teléfono',
    enter_sore_phone: 'Ingresa teléfono de la tienda',
    activate_survey:
        'Para activar la encuesta 1.1 Vespertino debes completar los objetivos de tiendas. Objetivos: ',
    inactive_vespertino: 'Vespertino inactivo',
    active_vespertino: 'Vespertino activo',
    completed_your_mandatory_objectives:
        'Has completado tus objetivos obligatorios del día, ya puedes realizar tu Vespertino.',
    complete_now: 'Completar ahora',
    perform_later: 'Realizar luego',
    back_to_your_agenda: '¿Deseas volver a tu agenda del día?',
    return_to_the_current_day:
        'Estás visualizando actividades de tus días anteriores, si tocás continuar volverás al día en curso: ',
    continue: 'Continuar',
    reached_your_goal: '¡Alcanzaste tu objetivo!',
    search_by_barcode: 'Busca por código de barras',
    scan_the_barcode:
        'Escanea el código de barras de cualquier producto\nen la lista de este relevamiento.',
    return_to_form: 'Volver a Formulario',
    product_not_found: 'Producto no encontrado',
    code_does_not_match:
        'El código no coincide con ningún producto correspondiente a este formulario.',
    search_another_product: 'Buscar otro producto',
    form_submitted_successfully: ' ha sido enviado con éxito!',
    send_new_survey: 'La encuesta se ha enviado correctamente.',
    no_agenda_for_today: '¡No hay agenda para el día de hoy!',
    consult_your_supervisor:
        'No cuentas con agenda para esta fecha, cualquier duda consulta con tu supervisor.',
    visiting_your_store: 'Estás visitando tu tienda ',
    you_can_check_out: 'Puedes realizar Check-out sin completar la encuesta: ',
    you_met_the_goal:
        'Cumpliste el objetivo, no es necesario que completes el formulario.',
    you_must_complete_the_survey:
        'Para realizar el Check-out debes completar la encuesta que corresponda al PDV que estás visitando: ',
    checkin_blocked: 'Check-in bloqueado',
    close_the_open_checkin: 'Para continuar debes cerrar el Check-in abierto.',
    close_the_checkin_opened_in:
        'Para continuar debes cerrar el Check-in abierto en: ',
    checkin_out_of_range: 'Check-in fuera de rango',
    more_meters_from_the_store: 'Estás a más de 150 metros de la tienda.',
    now_is_your_turn: '¡Ahora es tu turno!',
    surveys_in_progress: 'Tienes encuestas en curso: ',
    unfinished_surveys: 'Tienes encuestas sin realizar: ',
    want_to_checkout: '¿Estás seguro que deseas hacer Check-out?',
    selected_store: 'Tienda seleccionada',
    checkout_blocked: 'Check-out bloqueado',
    uncompleted_forms: '¡Tienes formularios sin completar!',
    checkout_anyway: '¿Quieres realizar el check-out de todos modos?',
    go_to_survey: 'Ir a encuesta',
    take_the_survey: '¡Ya puedes realizar la encuesta!',
    validity: 'Vigencia: ',
    search_store: 'Buscar tienda...',
    no_results_for_your_search: 'No hay resultados para tu búsqueda',
    find_another_store: 'Busca otra tienda',
    //nuevos al 21-11-2024
    loading: 'Cargando...',
    error_getting_data: 'Error al obtener los datos.',
    no_information_to_display: 'No hay información para mostrar.',
    unzipping: 'Descomprimiendo...',
    saving: 'Guardando',
    loading_stores: 'Cargando tiendas...',
    getting_stores: 'Obteniendo tiendas...',
    request_has_failed:
        'Máximo número de reintentos alcanzado. La solicitud ha fallado.',
    a_few_minutes: 'Cargando tiendas...\nEste proceso podría demorar unos minutos.',
    //nuevos al 27-01-2025
    assets_download_completed: 'Descarga de assets de Perfect Store finalizada',
    perfect_store_download: 'Descarga completa de foto de éxito',
    perfect_store_error: 'Error en la descarga de assets de Perfect Store',
    connection_interrupted:
        'Se volverá a descomprimir foto de éxito cuando recuperes conexión',
    decompressing_perfect_store: 'Descomprimiendo foto de éxito',
    downloading_perfect_store: 'Descargando foto de éxito',
    saving_perfect_store: 'Guardando foto de éxito',
    remain_downloaded: '\nFaltan descargar ',
    assets: ' imágenes.',
    download_complete: 'Descarga completa',

    //Portafolio
    no_brands_to_show: 'No hay marcas para mostrar',
    no_products_to_show: 'No hay productos para mostrar',
    try_again_later: 'Intente más tarde',
    portfolio: 'Portafolio',
    select_one:
        'Seleccione una de nuestras marcas para ver sus productos y servicios.',
    learn_about: 'Conozca toda la gama de productos y servicios de nuestra App.',
    //nuevos al 01-08-2024
    brand: 'Marca',
    description: 'Descripción',
    ingredients: 'Ingredientes',
    data_sheet: 'Archivos descargables',

    //Benefits
    points_can_be_exchanged: 'Pueden ser canjeados por: ',
    approved: 'Aprobado',
    cancelled: 'Cancelado',
    pending: 'Pendiente',
    redeemed: 'Canjeaste',
    added_points: 'Sumaste puntos',
    all: 'Todo',
    my_points: 'Mis puntos',
    your_points: 'Tus puntos',
    delivered: 'Entregado',
    no_benefits: 'Aún no hay beneficios',
    add_points: 'Sumá puntos con tus interacciones para poder canjearlos',
    no_history: 'Aún no hay historial',
    redeem_your_points: 'Canjea tus puntos y verás tu historial de beneficios aquí',
    pending_approval: 'Pendiente de aprobación',
    when_it_is_approved:
        'Cuando esté aprobado lo verás reflejado en tu historial de beneficios',
    unredeemed_benefit: 'Beneficio no canjeado',
    you_dont_have_enough_points:
        'No tienes los puntos suficientes para canjear este beneficio',
    accept: 'Aceptar',
    units_available: ' unidades disponibles',
    redeem_benefit: 'Redimir beneficio',
    benefits_mayus: 'BENEFICIOS',
    history: 'HISTORIAL',
    there_was_a_mistake: 'Hubo un error',

    //Vouchers
    complete_to_redeem_the_voucher: '¡Canjeá tu voucher!',
    valid_until: 'Vigencia hasta: ',
    quantity_purchased: 'Cantidad de bultos: ',
    redeem: 'Canjear',
    lumps: 'Bultos',
    voucher_redeemed: 'Voucher redimido con éxito',
    error_redeeming_voucher:
        'Hubo un error al redimir el voucher. Inténtalo de nuevo.',
    validate_and_redeem_vouchers: '¡Canjeá tu voucher!',
    to_get_started:
        'Captura el código QR para quemar tu voucher de manera rápida y sencilla. ¡No dejes pasar la oportunidad de aprovechar tus beneficios al instante!',
    write_your_code: 'Escribe tu código...',
    validate: 'Validar',
    back_to_store: 'Volver a Tienda',
    scan_qr: 'Escaneá el QR',
    scan_on_the_voucher: 'Para comenzar, escanea el QR del voucher',
    view_history: 'Ver historial',
    voucher_history: 'Historial de vouchers',
    voucher_history_description:
        'Este historial te permite tener un control preciso sobre los canjes realizados, facilitando el seguimiento y la gestión de tus recompensas acumuladas.',
    see_more: 'Ver más',
    see_less: 'Ver menos',

    //Faltantes
    upload_image: 'Cargar imagen',
    uploaded_image: 'Imagen cargada',
    photo: 'Foto',
    edit: 'Editar',
    delete: 'Borrar',
    enter_a_comment: 'Ingresa un comentario',
    enter_a_value: 'Ingresa un valor',
    want_to_check_out: '¿Estás seguro de realizar el check-out?',
    not_check_in_again:
        'Una vez confirmado, no podrás volver a realizar check-in hasta tu próxima visita.',

    //Alert
    alert: 'Alerta',
    enter_characters: 'Debes ingresar 10 caracteres después del prefijo',
    numerical_field: 'El campo a editar debe ser numérico, sin espacios, ni letras.',
    enter_date_of_birth:
        'Ingrese una fecha de nacimiento válida en el formato YYYY-MM-DD.',
    session_expired: 'Sesión expirada',
    your_session_has_expired: 'Su sesión ha expirado. Por favor, vuelva a intentar.',
    error: 'Error',
    error_occurred: 'Ha ocurrido un error al intentar cambiar la contraseña.',
    email_verification_code_incorrect:
        'El código de verificación del correo electrónico es incorrecto.',
    phone_verification_code_incorrect:
        'El código de verificación del número de teléfono es incorrecto.',
    no_checkin_found: 'No se encontra el checkin.',

    //trivia
    your_position: 'Tu posición',
    play_again: '¡Jugá de nuevo!',
    next: 'Siguiente',
    position: 'Puesto',
    Questions: 'Pregunta:',
    answer_right: 'La repuesta correcta es:',
    game_completed_title1: '¡Juego completado!',
    game_completed_title2: '¡Felicitaciones!',
    game_completed_title3: 'Terminaste la trivia.',
    game_completed_title4:
        '¿Listo para ver tus resultados? Descubrí cuántas respuestas acertaste',
    game_unfinished_title1:
        'Se terminó el tiempo para responder esta o las pregunta.',
    game_unfinished_title2:
        'Pero no te preocupes, ¡seguí jugando y demostrá tu conocimiento en la próxima!',
    tomorrow_again: '¡Nuevo intento mañana!',
    no_ranking_available_title: '¡Sé el primero en jugar!',
    no_ranking_text:
        'Todavía no hay posiciones. \nCompletá la trivia y estrená el ranking',
    no_trivia_available_title: '¡Sin trivias por ahora!',
    no_trivia_text: 'Pronto llegarán nuevas.',
    no_trivia_text2: '¡Estate atento!',
    no_podium_title: '¡El podio ya tiene dueños!',
    no_podium_text: '¿Jugaste ya? Sumate al ranking y mirá dónde quedás.',
    no_ranking_no_trivia_title: '¡Sin ranking disponible!',
    no_ranking_no_trivia_text:
        'Aún no hay partidas jugadas. ¡Pronto habrá novedades!',
    mensual: 'MENSUAL',
    acumulado: 'ACUMULADO',

    //Gamification
    game_again: '¡Vuelve a intentarlo!',
    game_Fail: 'No obtuviste el puntaje\nnecesario para avanzar.',
    game_rulette_again:
        '¡Gira la ruleta nuevamente\ny seguí jugando!\nNo obtuviste el puntaje\nnecesario para avanzar.',
    game_OK: 'Has aprobado el cuestionario.\nEstas más cerca del primer puesto.',
}
